import { isNil } from 'lodash';

const isAddButtonVisible = <T>(
  data: T[],
  index: number,
  maxLength?: number,
) => {
  const isLastValue = index === data.length - 1;

  if (maxLength) {
    return data.length < maxLength && isLastValue;
  }

  return isLastValue;
};

const isRemoveButtonVisible = <T>(data: T[]) => data.length > 1;

interface FormItemNameOptions {
  name: string;
  index?: number;
  prefix?: string;
}

const getFormItemName = (options: FormItemNameOptions) => {
  const { name, index, prefix } = options;

  let formItemName = name;

  if (!isNil(index)) {
    formItemName = `${index}.${formItemName}`;
  }

  if (prefix) {
    formItemName = `${prefix}.${formItemName}`;
  }

  return formItemName;
};

const getFormItemDataId = (name: string, index?: number) => {
  return !isNil(index) ? `${name}-${index}` : name;
};

export {
  isAddButtonVisible,
  isRemoveButtonVisible,
  getFormItemName,
  getFormItemDataId,
};
